import React, { useState } from "react";
import "./ContactSection.css";

function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState("");
  const [showBanner, setShowBanner] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus("Submitting...");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        access_key: "0aea328e-896e-4cf6-9df5-ba32d07a6a5c",
        ...formData,
      }),
    });

    const result = await response.json();

    if (result.success) {
      setFormStatus("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
    } else {
      setFormStatus("Failed to send message. Please try again.");
    }

    setShowBanner(true);
    setTimeout(() => setShowBanner(false), 3000);
  };

  return (
    <>
    <div className="contact-banner">
      <div className="contact-banner-overlay">
        <h1 className="contact-banner-title">Contact Us</h1>
      </div>
    </div>
    <div className="contact-wrapper">
      {showBanner && <div className="form-status-banner">{formStatus}</div>}

      <div className="contact-box">
        <form className="form-section" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-group full-width">
            <label htmlFor="message">Message Us</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="send-button">
            Send Message
          </button>
        </form>

        <div className="hours-section">
          <h3>Open Hours</h3>
          <ul>
            <li><span>Monday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Tuesday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Wednesday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Thursday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Friday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Saturday</span><span>6:00 AM - 2:00 PM</span></li>
            <li><span>Sunday</span><span>6:00 AM - 2:00 PM</span></li>
          </ul>
          <div className="contact-phone">
            <strong>Phone:</strong> 763-535-6202
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default ContactSection;
